import React from "react"
import WebsiteImage from "../../images/bakers-market/website.png"

const Website = () => {
  return (
    <div className="website py-5">
      <div className="title py-5">Baking goodness into technology</div>
      <img
        src={WebsiteImage}
        alt="barkers-market website"
        className="w-100 additional-bottom-padding"
      />
    </div>
  )
}

export default Website
